
import BillingExceptions from '@/components/BillingSettings/BillingExceptions.vue'
import BillingMultipliers from '@/components/BillingSettings/BillingMultipliers.vue'
import Vue from 'vue'

export default Vue.extend({
  name: 'BillingSettings',
  components: { BillingExceptions, BillingMultipliers },
})
